var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectronics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Vintage-Tv-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Vintage Tv 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5h-3a0.26 0.26 0 0 1 -0.22 -0.13 0.27 0.27 0 0 1 0 -0.26l2 -3A1 1 0 0 0 18.67 0.44l-2 2.94a0.26 0.26 0 0 1 -0.42 0l-2 -2.94a1 1 0 0 0 -1.66 1.11l2 3.05a0.27 0.27 0 0 1 0 0.26 0.26 0.26 0 0 1 -0.09 0.14h-12A1.47 1.47 0 0 0 1 6.43v13.13A1.47 1.47 0 0 0 2.5 21h1.83a0.24 0.24 0 0 1 0.23 0.14 0.27 0.27 0 0 1 0 0.27l-0.79 0.95a1 1 0 1 0 1.54 1.28l2.12 -2.55a0.25 0.25 0 0 1 0.2 -0.09h8.82a0.25 0.25 0 0 1 0.2 0.09l2.12 2.55a1 1 0 0 0 1.54 -1.28l-0.79 -0.95a0.27 0.27 0 0 1 0 -0.27 0.24 0.24 0 0 1 0.23 -0.14h1.75a1.47 1.47 0 0 0 1.5 -1.44V6.43A1.47 1.47 0 0 0 21.5 5ZM12 18a61 61 0 0 1 -7.06 -0.44 0.51 0.51 0 0 1 -0.44 -0.5V8.94a0.5 0.5 0 0 1 0.44 -0.5A61 61 0 0 1 12 8a61 61 0 0 1 7.06 0.44 0.5 0.5 0 0 1 0.44 0.5v8.12a0.51 0.51 0 0 1 -0.44 0.5A61 61 0 0 1 12 18Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectronics);
export default ForwardRef;